import messaging from "./firebase";


export const monitorearNotificacionesPush = () => {
    if ('serviceWorker' in navigator && messaging) {
        navigator
            .serviceWorker
            .register('/firebase-messaging-sw.js')
            .then((registration) => {
                messaging.useServiceWorker(registration);
                console.info("Service Worker de Firebase registrado correctamente");
            })
            .catch((err) => console.error("Error registrando el Service Worker:", err));


        messaging
            .onMessage((payload) => {
                console.log('Notificación Push recibida:', payload);
                const { title, body, click_action, icon } = payload.notification;

                // Verificar si la pestaña está activa
                const isActive = document.visibilityState === 'visible';
                if (isActive) {
                    // Si la pestaña esta Activa mostrar las notificaciones de la app
                    window.dispatchEvent(new CustomEvent('fcm-message', { detail: payload }));
                } else {
                    // Si la pestaña no esta activa mostrar las notificación del sistema
                    if (Notification.permission === 'granted') {
                        new Notification(title, {
                            body,
                            icon: icon || '/icon.png',
                        });
                    }
                }
            });
    }
};